import RoleManage from './RoleManage.vue'

RoleManage.install = function (Vue) {
    Vue.component(RoleManage.name, RoleManage)
}

import RoleEdit from './RoleEdit.vue'

RoleEdit.install = function (Vue) {
    Vue.component(RoleEdit.name, RoleEdit)
}

import RoleMenu from './RoleMenu.vue'

RoleMenu.install = function (Vue) {
    Vue.component(RoleMenu.name, RoleMenu)
}

import RoleUser from './RoleUser.vue'

RoleUser.install = function (Vue) {
    Vue.component(RoleUser.name, RoleUser)
}

export {RoleManage, RoleEdit, RoleMenu, RoleUser}
